/**
 * Pie "Con la tecnología de ReservaManager" del widget.
 *
 * POR QUÉ ASÍ (24-sep-2026, idea de Luis a partir de cómo lo hace Restoo): el
 * widget lo ve muchísima gente que no es cliente nuestro —comensales,
 * pacientes, el dueño del negocio de al lado— y es el escaparate más barato
 * que tenemos. Tres cosas que antes no estaban:
 *
 *  1. Aparecía SOLO en el widget de restaurantes. Ni en el de citas ni en las
 *     páginas donde el cliente gestiona/confirma/cancela su reserva o cita,
 *     que es donde más se entra.
 *  2. El enlace iba a la home y SIN marcar, así que no había forma de saber
 *     cuánta gente llegaba por ahí.
 *  3. Ahora lleva `utm_content` con el slug del negocio: se puede ver qué
 *     clientes nos traen visitas (Restoo hace exactamente eso).
 *
 * Decisión de producto de Luis: el pie se queda SIEMPRE, en todos los planes.
 */

const DESTINO = "https://reservamanager.com/para-tu-negocio";

export interface PoweredByProps {
  /** Slug del negocio: viaja como `utm_content` para saber quién nos trae visitas. */
  slug?: string | null;
  /** De qué pantalla sale el clic ("widget", "gestion-reserva", "gestion-cita"…). */
  origen?: string;
  /** Texto traducido ("Con la tecnología de"). */
  etiqueta: string;
  className?: string;
}

/** URL con las etiquetas de campaña ya puestas. */
export function poweredByUrl(slug?: string | null, origen = "widget"): string {
  const params = new URLSearchParams({
    utm_source: "widget",
    utm_medium: "powered-by",
    utm_campaign: origen,
  });
  if (slug) params.set("utm_content", slug);
  return `${DESTINO}?${params.toString()}`;
}

export default function PoweredBy({
  slug,
  origen = "widget",
  etiqueta,
  className = "",
}: PoweredByProps) {
  return (
    <div className={`text-center text-xs text-gray-400 ${className}`}>
      {etiqueta}{" "}
      <a
        href={poweredByUrl(slug, origen)}
        target="_blank"
        rel="noopener"
        className="text-primary-600 hover:underline"
      >
        ReservaManager
      </a>
    </div>
  );
}
